import * as React from "react";
import { observer } from "mobx-react-lite";
import { AColumn, AsyncTable } from "src/components/tables/AsyncTable";
import { selectOnRowClick } from "src/components/tables/selectOnRowClick";
import { ZBom2a } from "src/businessServices/services/bsBom2a/Bom2aTypes";
import { Bom2aPosCopyToStore } from "./Bom2aPosCopyToStore";

interface PropsBomPosCopyToStep2 {
  store: Bom2aPosCopyToStore;
}

export const Bom2aPosCopyToStep2: React.FC<PropsBomPosCopyToStep2> = observer(
  ({ store }) => {
    const { bomsStore } = store;
    if (!bomsStore) return null;
    return (
      <AsyncTable
        store={bomsStore}
        columns={columns}
        onRowClick={(row) => selectOnRowClick(row, bomsStore)}
      />
    );
  },
);

const columns: AColumn<ZBom2a>[] = [
  {
    key: "name",
    title: "Название",
    render: (_, { name }) => name,
  },
];
